import React from 'react';
import {DotLoading} from 'antd-mobile';

export const DotLoadingInBlock = (props) => {
  return <div className='p-8 text-center'>
    <DotLoading {...props} />
  </div>
}
